import { Flex, Box, Image } from "@chakra-ui/react";
import React, { lazy, Suspense, useState, useEffect, useRef } from "react";
import { useInView } from "framer-motion";

const Section5 = () => {
  const ref = useRef(null);
  const isInView = useInView(ref);
  return (
    <div>
      <Flex
        w="100%"
        alignItems="center"
        justifyContent="center"
        flexDir={{ base: "column", md: "row" }}
        mt="100px"
        ref={ref}
      >
        <Box
          w={{ base: "90%", md: "30%" }}
          borderRadius="50px"
          bg="#1a1a1a"
          h="700px"
          p="30px"
          position="relative"
          overflow="hidden"
          border="6px solid #131014"
          style={{
            transform: isInView ? "none" : "translateY(-200px)",
            opacity: isInView ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
        >
          <Box zIndex="2" fontSize={{ base: "30px", md: "40px" }}>
            Complex transactions, simplified.
          </Box>
          <Box mt="20px" color="gray.500">
            ChainPulse displays transaction information in an extremely easy to
            digest way that no other portfolio manager on the market does.
          </Box>
          <Box
            position="absolute"
            bottom="0"
            left="0"
            width="100%"
            height={{ base: "50%", md: "50%", lg: "50%", "2xl": "70%" }}
            zIndex="1"
            overflow="hidden"
          >
            <Image
              borderRadius="30px"
              src="https://i.imgur.com/0H2EkeR.gif"
              alt="Your Image"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "top",
                transform: isInView ? "none" : "translateY(-200px)",
                opacity: isInView ? 1 : 0,
                transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
              }}
            />
          </Box>
        </Box>
        <Box
          style={{
            transform: isInView ? "none" : "translateY(200px)",
            opacity: isInView ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
          mt={{ base: "20px", md: "0px" }}
          border="6px solid #131014"
          h="700px"
          w={{ base: "90%", md: "40%" }}
          ml={{ base: "0px", md: "40px" }}
          borderRadius={{ base: "50px" }}
          p="30px"
          bg="#1a1a1a"
          position="relative" // Ensure positioning context for absolutely positioned elements
          overflow="hidden" // Hide overflow to ensure the image stays within the Box
        >
          <Box zIndex="2" fontSize={{ base: "30px", md: "40px" }}>
            Unreal NFT info.
          </Box>
          <Box mt="20px" color="gray.500">
            Metadata, attributes, images. ChainPulse will track these details
            for all the NFTs in your wallet and display it in an easy to digest
            manner. ChainPulse is your ultimate NFT companion!
          </Box>
          <Image
            src="https://i.imgur.com/82HhIqc.gif"
            alt="Your Image"
            position="absolute"
            bottom={{ base: "0", md: "20" }}
            right="0"
            width={{ base: "100%", md: "90%" }}
            height="55%"
            objectFit="cover"
            borderRadius={{
              base: "20px 20px 0px 20px",
              md: "20px 0px 0px 20px",
            }}
          />
        </Box>
      </Flex>
    </div>
  );
};

export default Section5;
